// Axios
import axiosInstance from '../axios/axiosInstance';

const getCategoriaCompra = async () => {
  const res = await axiosInstance.get(`categoriaCompra/`);
  return res.data;
};

const categoriaService = {
  getCategoriaCompra,
};

export default categoriaService;
